import init from '../../helpers/init';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  $(document).on('submit', '.js-order-form', e => {
    e.preventDefault();

    const form = $(e.currentTarget);
    const order: any = form.serializeArray().reduce(function (accum: any, current) {
      accum[current.name] = current.value;
      return accum;
    }, {});

    BX.ajax.runComponentAction('pwd:exhibition.register.services', 'addOrder', {
      mode: 'class',
      data: {
        order
      },
    }).then((result: any) => {
      location.href = location.href.replace('services', 'order');
    })
      .catch((err: any) => console.log(err));
  });
});
